import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { adjuntarPactosATramite } from '../../services/pactoService';
import { descargarArchivo } from '../../services/archivoService';

function descargarBlob(data, nombreArchivo) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

/**
 * Traduce los datos de la tarjeta "Pacto de honorarios" a la elección que entiende
 * POST /api/pacto/tramite/{id} ({ variante, numeroHaberes }). Mismas reglas que
 * PactoDocumentoService.validarNumeroHaberes: sin el 30% hay plantilla para 1, 2 o 3 haberes;
 * con el 30%, solo para 2 o 3. Fuera de eso no hay pacto que emitir y devuelve null.
 */
export function pactoSegunTarjeta(cantidadHaberes, conPorcentaje) {
    const numeroHaberes = Number(cantidadHaberes);
    if (cantidadHaberes === '' || cantidadHaberes == null || !Number.isInteger(numeroHaberes)) {
        return null;
    }
    const validos = conPorcentaje ? [2, 3] : [1, 2, 3];
    if (!validos.includes(numeroHaberes)) {
        return null;
    }
    return { variante: conPorcentaje ? 'CON_PORCENTAJE' : 'SIN_PORCENTAJE', numeroHaberes };
}

/**
 * Botón "Generar pacto" de la ficha del trámite: emite el PACTO que corresponde a los haberes y
 * al 30% cargados en la tarjeta, lo deja en los Archivos del trámite y lo descarga.
 *
 * No genera nada por su cuenta: usa el mismo endpoint que el pacto del alta (ver
 * usePactosPendientes), que regenera el .docx con las plantillas de siempre, lo adjunta y deja
 * el "Pacto OK" en verde. Con el idArchivo que devuelve se descarga el documento ya guardado.
 *
 * `onGenerado` avisa a la ficha para que refresque Archivos y el checklist.
 */
export default function BotonGenerarPacto({ idTramite, cantidadHaberes, conPorcentaje, onGenerado }) {
    const [generando, setGenerando] = useState(false);

    if (!idTramite) {
        return null;
    }

    const pacto = pactoSegunTarjeta(cantidadHaberes, conPorcentaje);
    const ayuda = pacto
        ? null
        : conPorcentaje
            ? 'Con el 30% el pacto es por 2 o 3 haberes'
            : 'Cargue 1, 2 o 3 haberes para generar el pacto';

    const handleGenerar = async () => {
        setGenerando(true);
        try {
            const [archivo] = await adjuntarPactosATramite(idTramite, [pacto]);
            const response = await descargarArchivo(archivo.idArchivo);
            descargarBlob(response.data, archivo.nombre);
            toast.success(`Pacto guardado en los archivos del trámite. Descargando ${archivo.nombre}`);
            if (onGenerado) onGenerado();
        } catch (err) {
            console.error('❌ Error generando el PACTO del trámite:', err);
            toast.error('No se pudo generar el PACTO. Verifique que el cliente tenga domicilio cargado.');
        } finally {
            setGenerando(false);
        }
    };

    return (
        <div>
            <button
                type="button"
                className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2 rounded-pill"
                disabled={!pacto || generando}
                onClick={handleGenerar}
            >
                {generando
                    ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    : <i className="bi bi-file-earmark-word"></i>}
                Generar pacto
            </button>
            {ayuda && <div className="small text-muted mt-1">{ayuda}</div>}
        </div>
    );
}
